// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getDateDropdown, getFamilies } from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import CheckOrdersOrderSummaryTable from './components/check-orders-order-summary-table';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getCheckOrdersOrderSummary from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';

class CheckOrdersOrderSummary extends Component {

    state = {
        families: [],
        dateTypes: [],
        selectedFamily: '',
        selectedDateType: '',
        results: null
    };

    componentDidMount = () => {

        getFamilies( ).then( response => {

            this.props.increaseCounter();
            this.setState( {
                families: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        getDateDropdown( ).then( response => {

            this.props.increaseCounter();
            this.setState( {
                dateTypes: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamily: val,
            results: null
        } );

    }

    handleDateTypeChange ( val ) {

        this.setState( {
            selectedDateType: val,
            results: null
        }, () => {

            if ( this.state.selectedFamily !== '-1' && this.state.selectedDateType !== '-1' ) {

                this.refresh();

            }

        } );

    }

    refresh () {

        if ( this.state.selectedFamily !== '-1' && this.state.selectedDateType !== '-1' ) {

            this.props.increaseCounter();
            getCheckOrdersOrderSummary( this.state.selectedFamily, this.state.selectedDateType )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            selectedFamily, selectedDateType, families, dateTypes, results
        } = this.state;

        const finalCheckOrderResults = results !== null ? results.map( i => (
            { ...i, ...{ unitName: this.props.unit.name } } ) ) : [];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Check Orders - Order Summary</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-check-orders-order-summary-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-check-orders-summary-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={families}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamily}
                                />
                                <OptionsDropDown
                                    className="atp-check-orders-summary-select"
                                    label="Date"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleDateTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={dateTypes}
                                    placeholder="Select Date"
                                    selectedValue={selectedDateType}
                                />
                                {selectedFamily && selectedDateType && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                            </div>
                        </div>
                        { results !== null && results.length === 0 && (
                            <div className="errorMessage">There are no orders with code build weeks later than the order build week for family {selectedFamily} and a {selectedDateType} date. </div>
                        )}
                        { results !== null && results.length > 0 && (
                            <CheckOrdersOrderSummaryTable
                                results={finalCheckOrderResults}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

CheckOrdersOrderSummary.displayName = 'CheckOrdersOrderSummary';
CheckOrdersOrderSummary.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( CheckOrdersOrderSummary );
